export const CustomerTableColumns = [
  { id: 1, label: "Name", dataIndex: "name", visible: true },
  {
    id: 2,
    label: "Contact Information",
    dataIndex: "contactInfo",
    visible: true,
  },
  { id: 3, label: "Subscription", dataIndex: "subscription", visible: true },
  { id: 4, label: "Amount", dataIndex: "amount", visible: true },
  { id: 5, label: "Status", dataIndex: "status", visible: true },
];

export const FeedbackTableColumns = [
  { id: 1, label: "Name", dataIndex: "name", visible: true },
  {
    id: 2,
    label: "Contact Information",
    dataIndex: "contactInfo",
    visible: true,
  },
  { id: 3, label: "Role", dataIndex: "role", visible: true },
  { id: 4, label: "Feedback", dataIndex: "feedback", visible: true },
  { id: 5, label: "Experience", dataIndex: "experience", visible: true },
];

export const RevenueTableColumns = [
  { id: 1, label: "Month", dataIndex: "month", visible: true },
  { id: 2, label: "Total Revenue", dataIndex: "total", visible: true },
  { id: 3, label: "Subscription", dataIndex: "subscription", visible: true },
  { id: 4, label: "Invoice", dataIndex: "invoice", visible: true },
  { id: 5, label: "Add-on", dataIndex: "addon", visible: true },
];

export const TicketTableColumns = [
  { id: 1, label: "TICKET ID", dataIndex: "ticket_id", visible: true },
  { id: 2, label: "TITLE", dataIndex: "title", visible: true },
  { id: 3, label: "CUSTOMER", dataIndex: "customer", visible: true },
  { id: 4, label: "TYPE", dataIndex: "type", visible: true },
  { id: 5, label: "STATUS", dataIndex: "status", visible: true },
  { id: 6, label: "ASSIGNED TO", dataIndex: "assigned", visible: true },
];
